import {RecordForm} from '../forms/RecordForm';


import {useMeteringRecord} from '../hooks/useMeteringRecord.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";


export const AddPage = () => {

    const {
        record,
        createRecord,
    } = useMeteringRecord();

    return (
        <FormPageLayout
            title='Add Metering Record'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={record} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
